import Vue                      from "vue";
import { mapGetters }           from "vuex";

import { LoadingSpinner,
    PartDetailsLink,
    CurrencyText }              from "@/components";

import { 
    ErrorLogService,
    PartListBuilderService }    from "@/services";


export default Vue.extend({
    name: "ViewCrosses",
    components: {
        LoadingSpinner,
        PartDetailsLink,
        CurrencyText
    },

    mixins: [],
    props: {
        oemPartCode: {
            type: String,
            default: ""
        },
        quantity: {
            type: Number,
            default: 1
        },
        enteredItemId: {
            type: Number,
            default: -1
        }
    },
    computed: {
        ...mapGetters([
            "user", 
            "getContentItem", 
            "activeAccountId", 
            "user", 
            "audienceIds"
        ]),
    },
    created() {
        this.getCrosses();
    },
    data: () => ({
        crossItems: [],
        columns: [
            { key: "PartImage", label: "" },
            { key: "Part", lable: "Part" },
            { key: "Description", label: "Description" },
            { key: "Crosses", label: "Crosses" },
            { key: "UnitPrice", label: "Unit Price" },
            { key: "Replace", label: "" }
        ],
        isLoadingCrosses: false
    }),
    methods: {
        async getCrosses() {
            try {
                this.isLoadingCrosses = true;
                const params = {
                    accountId: this.activeAccountId,
                    userId: this.user.UserId,
                    userAudiences: this.audienceIds,
                    oemPartCode: this.oemPartCode.toUpperCase()
                };
                await PartListBuilderService.GetCrossReferences(params).then((result) => {
                    this.crossItems = result;
                });
            } catch (err) {
                ErrorLogService.LogException(err);

                this.$store.commit("pushTimedMessage", {
                    header: "There was an error getting the crosses for this part. Please try again. If the problem persists, please contact support.",
                    IsError: true,
                    seconds: 10,
                });
            } finally {
                this.isLoadingCrosses = false; 
            }
        },
        addCross(cross: any) {
            this.isLoadingCrosses = true;
            const params = {
                addRequest: {
                    accountId: this.activeAccountId,
                    userId: this.user.UserId,
                    partListId: 0,
                    userAudiences: this.audienceIds,
                    dealerPartNumber: null,
                    oemId: Number(cross.OriginalOemCode),
                    oemPartCode: cross.OriginalOemPartCode,
                    quantity: this.quantity,
                    stockingLocation: null
                },
                deleteRequest: {
                    accountId: this.activeAccountId,
                    userId: this.user.UserId,
                    partListId: 0,
                    userAudiences: this.audienceIds,
                    itemIds: [this.enteredItemId]
                }
            };

            this.$emit("add-cross-part", params);
        }
    },
});
